/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import {
  OTELNumberDataPoint,
  OTELNumberDataPoint$Outbound,
  OTELNumberDataPoint$outboundSchema,
} from "./otelnumberdatapoint.js";

/**
 * OTEL sum metric
 */
export type OTELSum = {
  /**
   * Aggregation temporality (number or enum string)
   */
  aggregationTemporality?: any | undefined;
  /**
   * Data points
   */
  dataPoints?: Array<OTELNumberDataPoint> | undefined;
  /**
   * Whether the sum is monotonic
   */
  isMonotonic?: boolean | undefined;
};

/** @internal */
export type OTELSum$Outbound = {
  aggregationTemporality?: any | undefined;
  dataPoints?: Array<OTELNumberDataPoint$Outbound> | undefined;
  isMonotonic?: boolean | undefined;
};

/** @internal */
export const OTELSum$outboundSchema: z.ZodMiniType<OTELSum$Outbound, OTELSum> =
  z.object({
    aggregationTemporality: z.optional(z.any()),
    dataPoints: z.optional(z.array(OTELNumberDataPoint$outboundSchema)),
    isMonotonic: z.optional(z.boolean()),
  });

export function otelSumToJSON(otelSum: OTELSum): string {
  return JSON.stringify(OTELSum$outboundSchema.parse(otelSum));
}
